import DispatcherBindModal from './dispatcherBind';

const userManagementModals = {
  DispatcherBindModal,
}
export default userManagementModals;


// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/userManagement/index.jsx